import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PeriodStatusBadgeComponent } from './period-status-badge.component';

@NgModule({
    imports: [
        CommonModule,
    ],
    declarations: [PeriodStatusBadgeComponent],
    exports: [PeriodStatusBadgeComponent]
})
export class PeriodStatusBadgeModule {}
